import { isEmpty } from '@ember/utils';
import { Changeset } from 'ember-changeset';
import type { DetailedChangeset, ValidatorAction } from 'ember-changeset/types';
import { regularExpressions } from 'ember-validators/format';
import type AgreementModel from 'garaje/models/agreement';
import invokeMap from 'lodash/invokeMap';

const buildChangeset = (model: AgreementModel): DetailedChangeset<AgreementModel> => {
  return Changeset(model, _validate);
};
class FakeChangeset {
  declare changesets: DetailedChangeset<AgreementModel>[];

  constructor(changesets: DetailedChangeset<AgreementModel>[] | null) {
    this.changesets = changesets ?? [];
  }

  get isDirty(): boolean {
    const changesets = this.changesets;
    return changesets.some((changeset) => changeset.isDirty || changeset.isInvalid);
  }

  get isPristine(): boolean {
    const changesets = this.changesets;
    return changesets.every((changeset) => changeset.isPristine);
  }

  rollback(): void {
    invokeMap(this.changesets, 'rollback');
  }
}

const _validate: ValidatorAction = ({ key, newValue }): boolean => {
  let isValid = true;

  if (key === 'bccEmail' && typeof newValue === 'string') {
    if (isEmpty(newValue) || newValue.indexOf('@') === -1) {
      isValid = false;
    }
  } else if (key === 'duration' && parseInt(<string>newValue) < 0) {
    isValid = false;
  } else if (key === 'videoUrl' && !isEmpty(newValue) && typeof newValue === 'string') {
    isValid = newValue.match(regularExpressions.url) !== null && newValue.match(/^https?:\/\//) !== null;
  }

  return isValid;
};

export { buildChangeset, FakeChangeset };
